import { pickingReportConfig } from '../../../../../core/configs/picking-report.config';
export const auditReport = {
  expandable: false,
  paginator: true,
  disabled: false,
  partialField: '',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  columns: [
    {
        title: 'Fecha de despacho',
        name: 'dispatchDate',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: any) =>
            element.dispatchDate ? element.dispatchDate : ''
    },
    {
        title: 'Inicio ventana horaria',
        name: 'startDateDeliveryWindow',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: any) => element.startDateDeliveryWindow
    },
    {
        title: 'Fin ventana horaria',
        name: 'endDateDeliveryWindow',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: any) => element.endDateDeliveryWindow
    },
    {
        title: 'Fecha de auditoría',
        name: 'auditDate',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: any) =>
            element.auditDate ? element.auditDate : ''
    },
    {
        title: 'N° Despacho',
        name: 'serialNumber',
        type: 'string',
        sortServer: true,
        class: 'number-order-picking',
        value: (element: any) => element.serialNumber
    },
    {
        title: 'Cod. Jaba',
        name: 'containerCode',
        type: 'string',
        sortServer: true,
        value: (element: any) => {
            return element.containerCode
            ? element.containerCode
            : '...';
        }
    },
    {
        title: 'SKU',
        name: 'skuCode',
        type: 'string',
        sortServer: true,
        class: 'center',
        value: (element: any) => element.skuCode
    },
    {
        title: 'Descripción',
        name: 'description',
        type: 'string',
        sortServer: true,
        class: 'center',
        value: (element: any) => element.description
    },
    {
        title: 'Cantidad Producto',
        name: 'amountTotal',
        type: 'string',
        sortServer: true,
        class: 'center',
        value: (element: any) => element.amount
    },
    {
        title: 'Resultado de Auditoría',
        name: 'auditResult',
        type: 'string',
        sortServer: true,
        class: 'center',
        value: (element: any) => element.isAudited ? element.auditedReason ? pickingReportConfig.OBSERVED_AUDIT_RESULT : pickingReportConfig.AGREED_AUDIT_RESULT : pickingReportConfig.NOT_AUDITED_AUDIT_RESULT
    },
    {
        title: 'Auditor',
        name: 'auditUser',
        type: 'string',
        sortServer: false,
        value: (element: any) => element.auditUser
    },    
    {
        title: 'Pickeador',
        name: 'picker.fullName',
        type: 'string',
        sortServer: true,
        value: (element: any) => {
            return element.picker
            ? element.picker
            : '...';
        }
    },
    {
        title: 'Motivo Auditado',
        name: 'auditReason',
        type: 'string',
        class: 'center',
        sortServer: true,
        value: (element: any) => element.isAudited ? element.auditedReason ? element.auditedReason : pickingReportConfig.AGREED_AUDIT_RESULT : ''
    }
  ]
};
